import { Component, OnInit } from '@angular/core';
import { CookieConsentService } from '../../core/services/cookie-consent.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-banner',
  standalone: false,
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
})
export class CookieBannerComponent implements OnInit {
  visible = false;

  constructor(
    private consent: CookieConsentService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.visible = !this.consent.hasAnswered();
  }

  acceptAnalytics() {
    this.consent.setAnalyticsConsent('accepted');
    this.visible = false;

    // If you initialise GA manually, call it here:
    // this.analytics.init();
  }

  rejectAnalytics() {
    this.consent.setAnalyticsConsent('rejected');
    this.visible = false;
  }

  openPolicy() {
    this.router.navigate(['/cookie-policy']);
  }
}
